import { CountdownWrapper } from '@components/Countdown/index.style'
import { GridMain } from '@components/Grid/index.style'
import { GridItemMain } from '@components/GridItem/index.style'
import { clamp } from '@styles/utils/conversion.style'
import { breakpoints } from '@styles/vars/breakpoints.style'
import { mq } from '@styles/vars/media-queries.style'
import { Heading2, TextBodySmall } from '@styles/vars/textStyles.style'
import styled from 'styled-components'

export const StickyCountdownWrapper = styled.div`
  position: relative;
  overflow: hidden;

  display: ${props => (props.show ? 'block' : 'none')};

  ${TextBodySmall} {
    display: none;

    ${mq.tabletL} {
      display: block;
    }
  }

  ${GridMain} {
    align-items: center;
    justify-content: center;
  }
`

export const StickyCountdownTitle = styled(Heading2)`
  ${clamp('font-size', 18, 32, breakpoints.desk, breakpoints.contained)};
  margin-right: 1.5rem;
`

export const StickyHideMobile = styled(GridItemMain)`
  display: none;

  ${mq.tabletL} {
    display: block;
  }
`
export const StickyCountdounInner = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;

  ${CountdownWrapper} {
    ${mq.tabletL} {
      ${clamp(
        'margin-right',
        18,
        62,
        breakpoints.tabletL,
        breakpoints.contained
      )}
    }
  }
`
